import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  slider: {
    // now style the track via pseudo-elements
    "&::-webkit-slider-runnable-track": {
      background: (props) => props.background,
    },
    "&::-webkit-slider-track": {
      background: (props) => props.background,
    },
    "&::-moz-range-track": {
      background: (props) => props.background,
    },
  },
});

/**
 * Simple slider component used for hue/saturation controls.
 * @param {Object} props Component props
 */
const Slider = (props) => {
  const { id, labelText, max, min, step, value, onChange } = props;
  const newClassName = useStyles(props);

  return (
    <div className="cp-slider">
      <label htmlFor={id}>
        {labelText}: {value}
      </label>
      <input
        className={newClassName.slider}
        type="range"
        name="base-color"
        min={min}
        max={max}
        value={value}
        onChange={onChange}
        id={id}
        step={step}
        label={`${labelText}: ${value}`}
      />
    </div>
  );
};

Slider.defaultProps = {
  background: "transparent",
};

//const jssSlider = withStyles(jssStyles)(Slider);

export default Slider;
